module.exports = __webpack_public_path__ + "static/media/comments2.001473c0.png";